var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpenedEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 19C5.839 19 .349 12.596.118 12.323a.5.5 0 0 1 0-.646C.348 11.404 5.838 5 12 5c7.18 0 11.722 6.441 11.91 6.716a.5.5 0 0 1-.028.607C23.65 12.596 18.16 19 12 19M1.172 12C2.365 13.29 7.06 18 12 18c4.98 0 9.704-4.778 10.854-6.027C21.858 10.703 17.779 6 12 6c-4.946 0-9.637 4.709-10.828 6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m0-7c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3"
})));
export default SvgOpenedEye;